import React, { useMemo } from 'react';

import { Grid, Section } from '@gogame/components';
import { FormField } from '@gogame/form';

import {
  loadInvoiceRequirements,
  loadPaymentTerms,
  loadExpenseTypes,
  loadTrafficRestrictions,
} from 'scenes/IO/sources/fields';

import {
  PAYMENT_TERMS_ID,
  EXPENSE_TYPE,
  TRAFFIC_RESTRICTIONS,
  INVOICE_REQUIREMENTS,
  ADDITIONAL_INVOICE_REQUIREMENTS,
  CONVERSIONS_APPROVAL_COMMENT,
  DEPENDENCIES,
} from '../constants';

const PaymentTerms = ({ name, active, disabled, value = {} }) => {
  const additionalInvoiseRequirementsVisible = useMemo(() => {
    return !!(
      value[INVOICE_REQUIREMENTS] && value[INVOICE_REQUIREMENTS].includes(3)
    );
  }, [value[INVOICE_REQUIREMENTS]]);

  return (
    <Section title={'Payment Terms'}>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <FormField.Select
            name={`${name}.${PAYMENT_TERMS_ID}`}
            label={'Payment terms'}
            disabled={disabled}
            depends={DEPENDENCIES[`${name}.${PAYMENT_TERMS_ID}`]}
            source={loadPaymentTerms}
            padding={0}
            required={true}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField.Select
            name={`${name}.${EXPENSE_TYPE}`}
            label={'Expense type'}
            active={active}
            disabled={disabled}
            depends={DEPENDENCIES[`${name}.${EXPENSE_TYPE}`]}
            source={loadExpenseTypes}
            padding={0}
            required={true}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField.MultiSelect
            name={`${name}.${TRAFFIC_RESTRICTIONS}`}
            label={'Traffic restrictions'}
            active={active}
            disabled={disabled}
            depends={DEPENDENCIES[`${name}.${TRAFFIC_RESTRICTIONS}`]}
            source={loadTrafficRestrictions}
            padding={0}
            required={true}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField.MultiSelect
            name={`${name}.${INVOICE_REQUIREMENTS}`}
            label={'Invoice requirements'}
            active={active}
            disabled={disabled}
            depends={DEPENDENCIES[`${name}.${INVOICE_REQUIREMENTS}`]}
            source={loadInvoiceRequirements}
            padding={0}
            required={true}
          />
        </Grid>

        {additionalInvoiseRequirementsVisible ? (
          <Grid item xs={8}>
            <FormField.TextField
              name={`${name}.${ADDITIONAL_INVOICE_REQUIREMENTS}`}
              label={'Additional invoice requirements'}
              disabled={disabled}
              padding={0}
            />
          </Grid>
        ) : null}
        <Grid item xs={8}>
          <FormField.TextField
            name={`${name}.${CONVERSIONS_APPROVAL_COMMENT}`}
            label={'Conversions approval comment'}
            disabled={disabled}
            padding={0}
          />
        </Grid>
      </Grid>
    </Section>
  );
};

export default PaymentTerms;
